import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-24 relative overflow-hidden" data-id="element-12">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] to-[#064e23] z-0" data-id="element-13" />

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-14">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#22C55E]/20 rounded-full blur-[100px]" data-id="element-15" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" id="precio" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-17">
          <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight" data-id="element-18">
            Transforma tu cuerpo <br data-id="element-19" /> y tu vida
          </h2>

          <p className="text-2xl md:text-3xl text-[#F59E0B] font-medium mb-10" data-id="element-20">
            Una microvictoria a la vez.
          </p>

          <div className="mb-8" data-id="element-21">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-22">
              <span className="text-2xl text-gray-500 line-through font-medium" data-id="element-23">
                $19.99
              </span>
              <span className="inline-block px-3 py-1 rounded-full bg-[#F59E0B]/20 border border-[#F59E0B]/30 text-[#F59E0B] text-sm font-bold tracking-wide uppercase" data-id="element-24">
                -50% OFF
              </span>
            </div>
            <p className="text-5xl md:text-7xl font-extrabold text-white tracking-tight" data-id="element-25">
              Por solo <span className="text-[#22C55E]" data-id="element-26">$9.99</span>
            </p>
          </div>

          <Button size="xl" glow className="w-full sm:w-auto text-lg px-12 py-8 text-xl shadow-2xl shadow-[#22C55E]/30" onClick={() => {
          trackAddToCart();
          window.location.href = 'https://lifestylevilofitness.com/cart/42172863742027:1';
        }} data-id="element-27">
            ¡Descarga tu copia ahora!
          </Button>

          <p className="mt-8 text-gray-400 text-sm" data-id="element-28">
            Acceso inmediato • Pago seguro • Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}